import { withStyles } from "@material-ui/core/styles";
import BaseChip from "src/components/common/Chips/BaseChip";

const DefaultChip = withStyles(() => ({
  root: {},
}))(BaseChip);

export default DefaultChip;
